export default __webpack_public_path__ + "static/media/he.ce80ab3c.svg";